import { render, staticRenderFns } from "./ProspectDocumentUpdate.vue?vue&type=template&id=249d3c21"
import script from "./ProspectDocumentUpdate.vue?vue&type=script&lang=ts"
export * from "./ProspectDocumentUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports